<template>
    <div class="row-start row-space">
        <div style="width: 700px;">
            <PieNotaChart :data="dadosNotasResumo" :labelsMap="labels" />
        </div>
    </div>

    <div v-if="dadosNotasMensal" class="row-start">
        <div style="width: 700px;">
            <BarNotasChart :data="dadosNotasMensal" title="Valor de Notas Registradas (últimos 12 meses)"/>
        </div>
    </div>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import { Api } from '@/funcoes/apiExport';
import { globalStore } from '@/globals';
import BarNotasChart from '@/components/charts/BarNotasChart.vue';
import PieNotaChart from '@/components/charts/PieNotaChart.vue';

const dadosNotasMensal = ref(null)
const dadosNotasResumo = ref({})

const labels = {
  vlcf: 'CF',
  vlnf: 'NF',
  vlnp: 'NP',
  vlns: 'NS',
}

async function lerNotasMensal(){
    const now = new Date();
    let inicio, fim;
    try{
        inicio = new Date(now.getFullYear(), now.getMonth() -11, 1);
        fim = new Date(now.getFullYear(), now.getMonth() + 1, 0);

        const r = await Api.genericPost('/dashboard/notas/valormensal', {
            idmunicipio: globalStore.idmunicipio,
            datainicial: inicio.toISOString().split('T')[0], 
            datafinal: fim.toISOString().split('T')[0]});
        dadosNotasMensal.value = r;
    }catch(error){console.error('Erro ao carregar resumo das notas:', error);}
}

async function lerNotasResumo(){
    try{
        const r = await Api.genericPost('/dashboard/notas/resumo', {idmunicipio: globalStore.idmunicipio, idprograma: globalStore.idprograma});
        dadosNotasResumo.value = r[0];
    }catch(error){console.error('Erro ao carregar resumo das notas:', error);}
}

onMounted(()=>{
    lerNotasResumo();
    lerNotasMensal();
})
</script>